module.exports = __webpack_public_path__ + "media/newstyle/images/icon-check-green-622f3e7640f814b8f3a2dfbee36ab991.svg";